import React, { useState, useEffect, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  Collapse,
  IconButton,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Autocomplete,
  Avatar,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { CiCirclePlus, CiFilter } from "react-icons/ci";
import { useForm, Controller, useWatch } from "react-hook-form";
import TargetPercentField from "../../components/utilisation/TargetPercentField";
import { DEFAULT_TARGET_PERCENT, validateTargetPercent } from "../../utils/utilisation";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { Offcanvas } from "react-bootstrap";
import QuillComponent from "../../components/common/ReactQuill";
import { ExpandMore } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import { createEntity, editProjectDetails, fetchEntityById, filterEntities } from "../../apis/apiService";
import { formatApiErrorMessage } from "../../utils/formatApiErrorMessage";
import { toast } from "react-toastify";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import Loader, { BtnLoader } from "../../components/common/Loader";
import { renderOverviewCell,} from "../../utils/mapOverviewData";
import {
  useFetchClientDetailsQuery,
  useFetchGenerateTestimonialLinkMutation,
  useFetchGetallProjectsQuery,
  useFetchNotificationListQuery,
  useFetchUserAccessedProjectsQuery,
  useDeleteTestimonialMutation,
} from "../../slice/logdetailSlice";
import dayjs from "dayjs";
import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
import { validateEndDate, validateStartDate } from "../../components/common/PreventValidate";
import { positiveNumberRule } from "../../utils/amount";
import { AddClientCompany, AddClientUser } from "../settings/ClientUser";
import { FiRefreshCw } from "react-icons/fi";
import { FilterSummaryBox } from "../../components/common/FilterSummaryBox";
import { useTheme } from "../../ThemeContext";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import CommonImportProject from "./CommonImportProject";


// project filter Component
const FilterProjectComponent = ({ onApply, onClear, onCancel }) => {
  const { isDarkMode } = useTheme();
  const [filters, setFilters] = useState([]);
  const [showProjectNames, setShowProjectNames] = useState([]);
  const UserNameOptions = useSelector(
    (state) => state.selectOptions.UserNameOptions
  );
  //console.log()("UserNameOptions : ", UserNameOptions);
  const activestatus = useSelector(
    (state) => state.selectOptions.StatusOptions
  );
  const activityStatus = activestatus.find(
    (status) => status.status_type === "PROJECT"
  );
  const ownerNames = useSelector(
    (state) => state.selectOptions?.ownerNameOptions
  );
  //console.log()("owner_names: ", ownerNames);

  const statusList = activityStatus?.status_details.map((status) => ({
    id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  //console.log()(" project filter activity status: ", statusList);
  //  project
  // const projectNames = useSelector(
  //   (state) => state.selectOptions.ProjectNameOptions
  // );
  const { data: projectNames } = useFetchUserAccessedProjectsQuery();
  // //console.log()(
  //   "projectNames_list getUserAccessedProject project_filter :",
  //   projectNames_list
  // );
  // const { data: projectNames } = useFetchGetallProjectsQuery();
  //console.log()(" project filter project names: ", projectNames);
  // //console.log()(" project filter project names: ", data);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sessionData = sessionStorage.getItem("isFilterApplied");
  const sessionFilter = sessionStorage.getItem("filtered_data");
  const filteredSessionData = JSON.parse(sessionFilter);
  // console.log("filteredSessionData :", filteredSessionData);

  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projecttitle: filteredSessionData ? filteredSessionData.title : [],
      owner: filteredSessionData ? filteredSessionData.project_manager_id : "",
      // createdBy: filteredSessionData ? filteredSessionData : "",
      createdDate: filteredSessionData?.added_at
        ? dayjs(filteredSessionData?.added_at)
        : null,
      lastModifiedBy: filteredSessionData ? filteredSessionData.updated_by : "",
      startDate: filteredSessionData?.start_date
        ? dayjs(filteredSessionData?.start_date)
        : null,
      endDate: filteredSessionData?.end_date
        ? dayjs(filteredSessionData?.end_date)
        : null,
      status: filteredSessionData ? filteredSessionData.current_status_id : "",
      billingType: filteredSessionData ? filteredSessionData.billing_type : "",
      added_by: filteredSessionData ? filteredSessionData.added_by : "",

      // selectedUsers: [],
    },
  });

  const onSubmit = async (data) => {
    const requestedData = {
      title: data.projecttitle,
      project_manager_id: parseInt(data.owner, 10) || null,
      start_date: data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
      billing_type: data.billingType || null,
      added_by: parseInt(data.added_by, 10) || null,
      current_status_id: data.status || null,
      added_at: data.createdDate
        ? format(new Date(data.createdDate), "yyyy-MM-dd")
        : null,
      updated_by: data.lastModifiedBy
        ? parseInt(data.lastModifiedBy, 10)
        : null,
      // updated_at: data.endDate,
      // filter: data.filter, // Array of selected user IDs
    };
    // console.log("filtered data:", requestedData);
    setIsSubmitting(true);

    try {
      const response = await filterEntities("/project/filter", requestedData);
      setFilters(response);
      //console.log()("filter data :", filters);
      if (response.data) {
        onApply(response.data);
        sessionStorage.setItem("filtered_data", JSON.stringify(requestedData));
        sessionStorage.setItem("isFilterApplied", true);

        toast.success(response.message);
      } 
      else {
        toast.error(response.message);
      }
      //console.log()(" filter response data:", response.data);
    } 
    catch (err) {
      const errorMessage = err.message || "Failed to fetch projects.";
      // console.error("Error fetching filtered projects:", err);
      toast.error(errorMessage);
    } 
    finally {
      setIsSubmitting(false);
    }
  };

  const handleClear = () => {
    reset();
    setValue("added_by", "");
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            Filter
          </div>
        </button>
        <div>
          <button
            type="button"
            onClick={handleClear}
            className="R_btn tex-tgba-red clear-filter-btn"
          >
            Clear Filter
          </button>
        </div>
      </div>
      <div className="bg-white px-4 py-3">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row mb-3">
                <div className="col-12">
                  <label htmlFor="projecttitle" className="form-label">
                    Search by projects
                  </label>
                  <Controller
                    name="projecttitle"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="projecttitle"
                        popupIcon={<ExpandMore />}
                        options={projectNames ? projectNames : []}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        value={
                          (value || []).map((title) =>
                            projectNames?.find((user) => user.title === title)
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedTitles = newValue.map(
                            (user) => user.title
                          );
                          onChange(selectedTitles);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter project name"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>
              </div>

              {/* Additional Fields */}
              {/* Owner and Created By Fields */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="owner" className="form-label">
                    Owner
                  </label>
                  <Controller
                    control={control}
                    name="owner"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              ownerNames.find(
                                (namelist) => namelist.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select owner</span>
                            )
                          }
                        >
                          {ownerNames.map((ownerName, index) => (
                            <MenuItem key={index} value={ownerName.user_id}>
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <label htmlFor="createdDate">Created Date</label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="createdDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            onChange={(date) => field.onChange(date)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                type="date"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            )}
                          />
                          {errors.createdDate && (
                            <span className="errorMsg">
                              {errors.createdDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>
              {/* created date creatated by */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="added_by" className="form-label">
                    Created By
                  </label>
                  <Controller
                    control={control}
                    name="added_by"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              ownerNames.find(
                                (namelist) => namelist.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                        >
                          {ownerNames.map((ownerName, index) => (
                            <MenuItem key={index} value={ownerName.user_id}>
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                <div className="col-md-6 mt-2">
                  <label htmlFor="lastModifiedBy">Last Modified By</label>
                  <Controller
                    name="lastModifiedBy"
                    control={control}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              ownerNames.find(
                                (namelist) => namelist.user_id === selected
                              )?.name
                            ) : (
                              <span className="lightText">Select user</span>
                            )
                          }
                        >
                          {ownerNames.map((ownerName, index) => (
                            <MenuItem key={index} value={ownerName.user_id}>
                              {ownerName.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {/* Date Fields */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="startDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            onChange={(date) => {
                              const endDate = getValues("endDate");
                              if (date && endDate && !validateStartDate(date, endDate)) {
                                const current = getValues("startDate");
                                setValue("startDate", null);
                                setTimeout(() => setValue("startDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input
                                className="form-control datepic_ip"
                                {...params}
                              />
                            )}
                          />
                          {errors.startDate && (
                            <span className="errorMsg">
                              {errors.startDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="endDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            format="DD/MM/YYYY"
                            {...field}
                            onChange={(date) => {
                              const startDate = getValues("startDate");
                              if (date && startDate && !validateEndDate(startDate, date)) {
                                const current = getValues("endDate");
                                setValue("endDate", null);
                                setTimeout(() => setValue("endDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input
                                className="form-control datepic_ip"
                                {...params}
                              />
                            )}
                          />
                          {errors.endDate && (
                            <span className="errorMsg">
                              {errors.endDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>

              {/* Status and Billing Type */}
              <div className="row mb-3 paddingBtn">
                <div className="col-md-6">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <FormControl fullWidth>
                    <Select
                      value={watch("status") || ""} // Use watch to track the current value
                      onChange={(e) => setValue("status", e.target.value)} // Update form value
                      IconComponent={ExpandMore}
                      displayEmpty
                      // renderValue={(selected) =>
                      //   selected ? (
                      //     statusList.find(
                      //       (statusName) => statusName.id === selected
                      //     )?.status_name
                      //   ) : (
                      //     <span className="lightText">Select status</span>
                      //   )
                      // }
                      renderValue={(selected) => {
                        const selectedStatus = statusList.find(
                          (status) => status.id === selected
                        );

                        return selectedStatus ? (
                          <span style={{ color: selectedStatus.status_colour }}>
                            {selectedStatus.status_name}
                          </span>
                        ) : (
                          <span className="lightText">Select status</span>
                        );
                      }}
                    >
                      {statusList.map((status, index) => (
                        <MenuItem
                          key={index}
                          style={{ color: status.status_colour || "black" }}
                          value={status.id}
                        >
                          {status.status_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="col-md-6">
                  <label htmlFor="billingType" className="form-label">
                    Billing Type
                  </label>
                  <Controller
                    control={control}
                    name="billingType"
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          IconComponent={ExpandMore}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">Select type </span>
                            )
                          }
                        >
                          <MenuItem value="BILLABLE">Billable</MenuItem>
                          <MenuItem value="NON-BILLABLE">Non-Billable</MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
              </div>

              {/* Buttons */}
              {/* <div className='d-flex justify-content-center mt-3'>
                <button
                  type='submit'
                  className='add_btn me-3'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Applying...' : 'Apply'}
                </button>
                <button type='button' className='cancel_btn' onClick={onCancel}>
                  Cancel
                </button>
              </div> */}
              <div className="bg-white position-absolute w-100 bottom-0 py-3">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="add_btn me-3"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Apply"
                    )}
                  </button>
                  <button
                    type="button"
                    disabled={isSubmitting}
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};



// Add project  Component
export const AddProjectComponent = ({
  onApply,
  onClear,
  onCancel,
  fetchProjects,
}) => {
  const { isDarkMode } = useTheme();
  const [budgetOpen, setBudgetOpen] = useState(true);
  const [selectedBudgetType, setSelectedBudgetType] = useState("");
  const [uploadedFile, setUploadedFile] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [showCompany, setShowCompany] = useState(false);
  const { data, refetch: projectNames } = useFetchGetallProjectsQuery();
  const { data: notification_list, refetch: notification_refetch } =
    useFetchNotificationListQuery();
  const StatusOptions = useSelector(
    (state) => state.selectOptions?.StatusOptions
  );
  //console.log()("status_optionsss :", StatusOptions);
  const currentDate = dayjs();
  const UserNameOptions = useSelector(
    (state) => state.selectOptions?.UserNameOptions
  );
  //console.log(UserNameOptions, "UserNameOptions");

  // const ClientOptions = useSelector(
  //   (state) => state.selectOptions?.ClientNameOptions
  // );
  const {
    data: ClientOptions = [],
    refetch: client_detail_refetch,
    isLoading: client_loading,
  } = useFetchClientDetailsQuery();
  // console.log("UserNameOptions", ClientOptions);

  const {
    handleSubmit,
    control,
    reset,
    register,
    clearErrors,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      projecttitle: "",
      owner: "",
      createdBy: "",
      createdDate: null,
      lastModifiedBy: "",
      startDate: currentDate,
      endDate: null,
      status: "",
      // BillingMethod: "",
      description: "",
      users: [],
      currency: "INR",
      budgetType: "",
      BudgetedHours: "",
      TotalBudget: "",
      TargetPercent: DEFAULT_TARGET_PERCENT,
      costBudget: 0,
      billingType: "BILLABLE",
      projectAccess: "Private",
      addedby: 0,
      Client: [],
    },
  });
  const totalBudgetValue = useWatch({ control, name: "TotalBudget" });
  const ownerNames = useSelector(
    (state) => state.selectOptions.ownerNameOptions
  );
  //console.log()("owner_names: ", ownerNames);
  useEffect(() => {
    // Find the default status_id (22)
    const defaultStatus = StatusOptions.find(
      (option) => option.status_type === "PROJECT"
    )?.status_details.find((detail) => detail.status_id === 22);

    if (defaultStatus) {
      // reset() replaces every default, so the ones the form still relies on are repeated here
      reset({ status: defaultStatus.status_id, TargetPercent: DEFAULT_TARGET_PERCENT });
    }
  }, [StatusOptions, reset]);
  const onSubmit = async (data) => {
    const requestData = {
      title: data.projecttitle,
      project_manager_id: data.owner,
      start_date: data.startDate
        ? format(new Date(data.startDate), "dd-MM-yyyy")
        : null,
      end_date: data.endDate
        ? format(new Date(data.endDate), "dd-MM-yyyy")
        : null,
      description: data.description,
      users: data.users,
      currency: data.currency,
      ...(data?.budgetType !== "None" && {
        budget_type: data.budgetType,
      }),
      budgeted_hours: data.BudgetedHours,
      total_budget: data.TotalBudget,
      ...(selectedBudgetType === "FIXED_COST" && {
        target_percent: Number(data.TargetPercent),
      }),
      // revenue_budget: data.revenueBudget,
      // cost_budget: data.costBudget,
      billing_method: data.billingType,
      project_access: data.projectAccess,
      added_by: data.addedby,
      current_status: data.status,
      clients: data.Client,
      document: uploadedFile,
    };
    //console.log()("project_requested data :", requestData);

    setIsSubmitting(true);
    try {
      const response = await createEntity("projects/add", requestData);
      toast.success("Project created successfully!");
      reset();
      onCancel();
      projectNames();
      notification_refetch();

      if (fetchProjects) {
        fetchProjects();
      }
      // onApply(response.data);
    } catch (error) {
      const errorMsg = formatApiErrorMessage(error, "Failed to create project. Please try again.");
      toast.error(errorMsg);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleBudgetToggle = () => {
    setBudgetOpen((prev) => !prev);
  };

  // Transform Redux data for Autocomplete options
  const userOptions = UserNameOptions.map((user) => ({
    name: user.name,
    user_id: user.user_id,
    avatar: user.image_url, // Use the first character as an avatar fallback
    designation: user.designation,
  }));
  //console.log()("userOptions :", userOptions);

  const BudgetOptions = [
    { value: "FIXED_COST", label: "Fixed Cost" },
    { value: "TIME_AND_MATERIAL", label: "Time & Material" },
    { value: "CONTRACT", label: "Monthly Contract" },
    { value: "None", label: "None" },
    // { value: 'Based on Project', label: 'Based on Project' },
  ];
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  //  handel Budgettype select
  const handleBudgetTypeChange = (e) => {
    setSelectedBudgetType(e.target.value);
    setValue("budgetType", e.target.value);
  };
  const showClientList = () => {
    setShowProject(true);
  };
  const handleCloseProject = () => {
    setShowProject(false);
  };
  return (
    <div className="">
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <AddClientUser
            onCancel={handleCloseProject}
            fetchClient={client_detail_refetch}
            showCompany={() => setShowCompany(true)}
          // client_detail_refetch={client_detail_refetch}
          // onApply={handleAddTask}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <Offcanvas
        show={showCompany}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <AddClientCompany
            onCancel={() => setShowCompany(false)}
            fetchClient={client_detail_refetch}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack className="me-1" />
            Add New Project
          </div>
        </button>
      </div>
      <div className="bg-white overflow-scroll pb-5 pt-3 px-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="">
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="projecttitle" className="form-label">
                    Project Title<span className="text-rgbr-red"> *</span>
                  </label>
                  <TextField
                    id="projecttitle"
                    placeholder="Enter Project Title"
                    fullWidth
                    variant="outlined"
                    {...register("projecttitle", {
                      required: "Project Title is required",
                    })} // Add validation rule here
                  />
                  {errors.projecttitle && (
                    <span className="errorMsg">
                      {errors.projecttitle.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="owner" className="form-label">
                    Owner<span className="text-rgbr-red"> *</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="owner"
                      control={control}
                      rules={{ required: "Owner field is required" }}
                      render={({
                        field: { onChange, value },
                        formState: { errors },
                      }) => (
                        <>
                          <Autocomplete
                            id="owner"
                            popupIcon={<ExpandMore />}
                            options={
                              Array.isArray(ownerNames) ? ownerNames : []
                            }
                            getOptionLabel={(option) => option.name}
                            value={
                              ownerNames?.find(
                                (user) => user.user_id === value
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                if (Array.isArray(newValue)) {
                                  toast.error("You can select only one user.");
                                } else {
                                  onChange(newValue.user_id);
                                  setSelectedOwner(newValue.user_id); // Set selected user ID
                                }
                              } else {
                                onChange(null);
                                setSelectedOwner(null); // Reset selected user ID
                              }
                            }}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                <strong>{option.name}</strong>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select owner"
                              />
                            )}
                          />
                          <span className="errorMsg">
                            {errors?.owner?.message}
                          </span>
                        </>
                      )}
                    />
                  </FormControl>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="startDate" className="form-label">
                    Start Date
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="startDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            className="datepicker_input"
                            onChange={(date) => {
                              const endDate = getValues("endDate");
                              if (date && endDate && !validateStartDate(date, endDate)) {
                                const current = getValues("startDate");
                                setValue("startDate", null);
                                setTimeout(() => setValue("startDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input
                                className="form-control datepicker_input"
                                {...params}
                              />
                            )}
                          />
                          {errors.startDate && (
                            <span className="errorMsg">
                              {errors.startDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <label htmlFor="endDate" className="form-label">
                    End Date
                  </label>
                  <div className=" d-flex  flex-column w-100 ">
                    <Controller
                      name="endDate"
                      control={control}
                      rules={{
                        validate: (val) => {
                          if (!val) return true;
                          const d = dayjs(val);
                          if (!d.isValid()) return "Invalid date format";
                          if (d.year() < 1990) return "Invalid date format";
                          return true;
                        }
                      }}
                      render={({ field }) => (
                        <>
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            onChange={(date) => {
                              const startDate = getValues("startDate");
                              if (date && startDate && !validateEndDate(startDate, date)) {
                                const current = getValues("endDate");
                                setValue("endDate", null);
                                setTimeout(() => setValue("endDate", current), 0);
                                return;
                              }
                              field.onChange(date);
                            }}
                            renderInput={(params) => (
                              <input
                                className="form-control datepic_ip"
                                {...params}
                              />
                            )}
                          />
                          {errors.endDate && (
                            <span className="errorMsg">
                              {errors.endDate.message}
                            </span>
                          )}
                        </>
                      )}
                    />
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <QuillComponent
                    control={control}
                    name="description"
                    label="Description"
                  />
                </div>

                {/* <div className="col-md-12 pt-3">
                  <label htmlFor="Upload File" className="form-label">
                    Upload File
                  </label>
                  <FileUpload onFileChange={(file) => setUploadedFile(file)} />
                </div> */}

                <div className="col-md-12 pt-3">
                  <label htmlFor="status" className="form-label">
                    Status <span className="text-rgbr-red"> *</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      control={control}
                      name="status"
                      render={({ field }) => (
                        <Select
                          {...field}
                          id="status"
                          IconComponent={ExpandMore}
                          onChange={(e) => {
                            field.onChange(e);
                            clearErrors("status");
                          }}
                          displayEmpty
                          renderValue={(selected) => {
                            const selectedStatus = StatusOptions.find(
                              (option) => option.status_type === "PROJECT"
                            )?.status_details.find(
                              (detail) => detail.status_id === selected
                            );

                            return selectedStatus ? (
                              <span
                                style={{ color: selectedStatus.status_colour }}
                              >
                                {selectedStatus.status_name}
                              </span>
                            ) : (
                              <span className="lightText">Select status</span>
                            );
                          }}
                        >
                          {StatusOptions?.find(
                            (option) => option.status_type === "PROJECT"
                          )?.status_details.map((status, index) => (
                            <MenuItem key={index} value={status.status_id}>
                              <span style={{ color: status.status_colour }}>
                                {status.status_name}
                              </span>
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                      rules={{ required: "Status is required" }}
                    />
                  </FormControl>
                  {errors.status && (
                    <span className="errorMsg">{errors.status.message}</span>
                  )}
                </div>

                <div className="col-md-12 pt-3">
                  <label htmlFor="users" className="form-label">
                    Add Users
                    {/* <span className="text-rgbr-red"> *</span> */}
                  </label>
                  <Controller
                    name="users"
                    control={control}
                    // rules={{ required: "Users  is required" }}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="users"
                        popupIcon={<ExpandMore />}
                        options={userOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name}
                        value={
                          value?.map((id) =>
                            userOptions.find((user) => user.user_id === id)
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (user) => user.user_id
                          );
                          onChange(selectedIds); // Update form state with user IDs
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex flex-column align-items-center flex-md-row mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <Avatar
                              src={option.avatar}
                              alt={option.name}
                              style={{ marginRight: 8 }}
                            ></Avatar>
                            <div className="d-flex flex-column mt-2">
                              <strong>{option.name}</strong>
                              <span>{option.designation}</span>
                            </div>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Users Name"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr", // Two columns
                            gap: "8px",
                            paddingLeft: "0", // Removes default padding
                          },
                        }}
                      />
                    )}
                  />

                  {/* {errors.users && (
                    <span className="errorMsg">{errors.users.message}</span>
                  )} */}
                </div>
                <div className="col-md-12 mt-3">
                  <label htmlFor="Client" className="form-label"></label>
                  <label htmlFor="Company Name" className="form-label w-100">
                    <div className="d-flex justify-content-between align-items-center">
                      <span>Add Client</span>
                      <div className="d-flex align-items-center gap-3 justify-content-center">
                        <Tooltip title="Refresh">
                          <span
                            style={{
                              cursor: client_loading
                                ? "not-allowed"
                                : "pointer",
                            }}
                          >
                            <FiRefreshCw
                              color="teal"
                              opacity={0.8}
                              fontSize={20}
                              onClick={client_detail_refetch}
                            />
                          </span>
                        </Tooltip>

                        <Tooltip title="Add Client">
                          <span>
                            <CiCirclePlus
                              color="teal"
                              fontSize={22}
                              style={{ cursor: "pointer" }}
                              onClick={showClientList}
                            />
                          </span>
                        </Tooltip>
                      </div>
                    </div>
                  </label>
                  <Controller
                    name="Client"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        multiple
                        id="Client"
                        popupIcon={<ExpandMore />}
                        options={ClientOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.name} // Show name
                        value={
                          (value || []).map((id) =>
                            ClientOptions.find((user) => user.user_id === id)
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (user) => user.user_id
                          ); // Save user_id
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <div className="d-flex flex-column mt-2">
                              <strong>{option.name}</strong>
                              <span>{option.company_name}</span>
                            </div>
                            {/* <strong>{option.name}</strong> */}
                            {/* <p>option</p> */}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Client Name"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="row mb-3">
                <p
                  className="d-inline border-0 text-start w-auto my-4"
                  onClick={() => setBudgetOpen((open) => !open)}
                >
                  BUDGET{budgetOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </p>
                <Collapse timeout={700} in={budgetOpen}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="currency" className="form-label">
                        Currency
                      </label>
                      <div class="input-group mb-3">
                        {/* <span class="input-group-text">INR</span> */}
                        <Controller
                          name="currency"
                          control={control}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              type="text"
                              sx={{ width: "100%" }}
                              placeholder="Enter value"
                              id="currency"
                              className="form-control"
                              value={field.value || "INR"} // fallback
                              InputProps={{ readOnly: true }}
                            />
                          )}
                        />
                        {/* <TextField
                          type="number"
                          sx={{ width: "100%" }}
                          placeholder="Enter value"
                          id="currency"
                          value="INR"
                          className="form-control"
                          onChange={(event) => {
                            preventNegativeValues(event);
                          }}
                          disabled
                          {...control.register("currency")}
                          inputProps={{ min: 0 }}
                        /> */}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="budgetType" className="form-label">
                        Budget Type
                      </label>
                      <FormControl fullWidth>
                        <Select
                          labelId="budgetType-label"
                          id="budgetType"
                          value={selectedBudgetType}
                          {...control.register("budgetType")}
                          IconComponent={ExpandMore}
                          onChange={handleBudgetTypeChange}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              BudgetOptions.find(
                                (list) => list.value === selected
                              )?.label
                            ) : (
                              <span className="lightText">
                                Select budget type
                              </span>
                            )
                          }
                        >
                          {BudgetOptions.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  {selectedBudgetType === "FIXED_COST" && (
                    <div className="row mb-3">
                      <div className="col-md-6 gap-2 mb-3">
                        <div className="flex gap-2">
                          <label htmlFor="BudgetedHours" className="form-label">
                            Budgeted Hours
                          </label>
                          <div class="input-group mb-3">
                            <span
                              class="input-group-text"
                              style={{
                                backgroundColor: "var(--header-bg-color)",
                                color: "var(--text-color)",
                              }}
                            >
                              Hrs
                            </span>
                            <TextField
                              type="number"
                              id="BudgetedHours"
                              className="form-control"
                              inputProps={{ min: 1 }}
                              error={Boolean(errors.BudgetedHours)}
                              {...control.register("BudgetedHours", {
                                validate: positiveNumberRule("Budgeted Hours"),
                              })}
                            />
                          </div>
                          {errors.BudgetedHours && (
                            <span className="errorMsg">{errors.BudgetedHours.message}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 gap-2 mb-3">
                        <div className="flex gap-2">
                          <label htmlFor="TotalBudget" className="form-label">
                            Total Budget
                          </label>
                          <div class="input-group mb-3">
                            <span
                              class="input-group-text"
                              style={{
                                backgroundColor: "var(--header-bg-color)",
                                color: "var(--text-color)",
                              }}
                            >
                              INR
                            </span>
                            <TextField
                              type="number"
                              id="TotalBudget"
                              className="form-control"
                              inputProps={{ min: 1 }}
                              error={Boolean(errors.TotalBudget)}
                              {...control.register("TotalBudget", {
                                validate: positiveNumberRule("Total Budget"),
                              })}
                            />
                          </div>
                          {errors.TotalBudget && (
                            <span className="errorMsg">{errors.TotalBudget.message}</span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 gap-2 mb-3">
                        <Controller
                          name="TargetPercent"
                          control={control}
                          rules={{ validate: (value) => validateTargetPercent(value) ?? true }}
                          render={({ field, fieldState }) => (
                            <TargetPercentField
                              mode="create"
                              id="TargetPercent"
                              name={field.name}
                              budget={totalBudgetValue}
                              value={field.value ?? ""}
                              onChange={field.onChange}
                              onBlur={field.onBlur}
                              inputRef={field.ref}
                              showError={fieldState.isTouched || Boolean(fieldState.error)}
                            />
                          )}
                        />
                      </div>
                    </div>
                  )}
                  <div className="row mb-3">
                    <div className="col-md-12 d-flex align-items-center">
                      <div className="me-3">
                        <label htmlFor="billingType" className="form-label">
                          Billing Method{" "}
                          <span className="text-rgbr-red"> *</span>
                        </label>
                      </div>
                      <div>
                        <Controller
                          name="billingType"
                          control={control}
                          // rules={{ required: "Billing Method is required" }} // Add validation rule
                          render={({ field }) => (
                            <RadioGroup
                              row
                              {...field}
                              onChange={(e) => field.onChange(e.target.value)} // Explicitly update value
                              value={field.value || ""} // Ensure value is handled
                            >
                              <FormControlLabel
                                value="BILLABLE"
                                control={<Radio />}
                                label="Billable"
                              />
                              <FormControlLabel
                                value="NON-BILLABLE"
                                control={<Radio />}
                                label="Non - Billable"
                              />
                            </RadioGroup>
                          )}
                        />
                      </div>
                      {/* Display error for Billing Method */}
                      {/* {errors.billingType && (
                        <span className="errorMsg">
                          {errors.billingType.message}
                        </span>
                      )} */}
                    </div>
                  </div>
                </Collapse>
                {/* Budget Fields - Collapsible Section */}
              </div>
              <div className="bg-white position-absolute w-100 bottom-0 py-3">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="position-relative add_btn me-3"
                    disabled={isSubmitting}
                  // style={{
                  //   display: "flex",
                  //   alignItems: "center",
                  //   justifyContent: "center",
                  //   gap: "5px",
                  // }}
                  >
                    {isSubmitting ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      "Add"
                    )}
                  </button>

                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                    disabled={isSubmitting}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

const Project = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const { reset } = useForm();

  const [filter, setFilter] = useState("all_projects");
  const [projects, setProjects] = useState([]);
  const [columns, setColumns] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  // const MySwal = withReactContent(Swal);
  //console.log()(totalRecords, "totalRecords");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [generateTestimonialLink, { isLoading: isGeneratingTestimonialLink }] = useFetchGenerateTestimonialLinkMutation();
  const [deleteTestimonial, { isLoading: deleteLoading }] = useDeleteTestimonialMutation();
  const [clearFilter, setClearFilter] = useState(false);
  // for  view by owner
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState();
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [selectedVideoData, setSelectedVideoData] = useState(null);

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log()("login_user in pproject:", login_user);
  const login_user_role = login_user?.role;
  //console.log()("login_user role in project:", login_user_role);
  const getFlattenedRows = () => {
    const flattenedRows = [];
    projects?.forEach((row) => {
      flattenedRows.push(row); // Add parent row
      if (expandedRows[row.id]) {
        row.subtasks.forEach((subtask) => {
          flattenedRows.push({ ...subtask }); // Add subtasks when expanded
        });
      }
    });
    return flattenedRows;
  };

  const handleMenuOpen = (event, row) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    const testimonialId =
      row.testimonial
        ? row.testimonial.testimonial_id
        : null;
    setSelectedTask({
      project_id: row.project_id,
      project_name: row.title,
      testimonial_id: testimonialId,
      has_testimonials: !!(row.testimonial),
    });
  };

  const activestatus = useSelector(
    (state) => state.selectOptions?.StatusOptions || []
  );
  const projectStatusGroup = activestatus.find(
    (status) => status.status_type === "PROJECT"
  );
  const projectStatusList = projectStatusGroup?.status_details || [];

  const filterOptions = useMemo(() => {
    const options = [{ label: "All Projects", value: "all_projects" }];

    if (Array.isArray(projectStatusList)) {
      projectStatusList.forEach((st) => {
        if (st?.status_name && !options.some((o) => o.value === st.status_name)) {
          options.push({
            label: st.status_name,
            value: st.status_name,
          });
        }
      });
    }

    return options;
  }, [projectStatusList]);

  const baseProjectColumns = [
    { field: "project_id", headerName: "ID", sortable: true, width: 100 },
    {
      field: "title",
      headerName: "Projects",
      sortable: true,
      width: 200,
      // headerClassName: "custom-header",
    },
    { field: "owner_name", headerName: "Owner", sortable: true, width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 120,
      renderCell: (params) => {
        const status = params.value;
        const color = params.row.status_colour || "black";
        return <span style={{ color: color }}>{status}</span>;
      },
    },
    {
      field: "budget_type",
      headerName: "Budget Type",
      sortable: true,
      width: 160,
      renderCell: (params) => {
        const val =
          params.value ??
          params.row?.budget_type ??
          params.row?.budgetType;
        if (!val || !String(val).trim() || String(val).trim().toUpperCase() === "NONE") {
          return "-";
        }
        const str = String(val).trim();
        const upper = str.toUpperCase();
        if (upper === "FIXED_COST" || upper === "FIXED") return "Fixed Cost";
        if (
          upper === "TIME_AND_MATERIAL" ||
          upper.startsWith("TIME_AND_") ||
          upper.startsWith("TIME AND ")
        ) {
          return "Time And Material";
        }
        if (upper === "CONTRACT") return "Contract";
        if (upper === "MONTHLY_CONTRACT") return "Monthly Contract";

        return str
          .split(/[_\s]+/)
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join(" ");
      },
    },
    {
      field: "completed_percentage",
      headerName: "Completed %",
      sortable: true,
      width: 110,
    },

    { field: "added_by_name", headerName: "Created By", width: 150 },
    {
      field: "start_date",
      headerName: "Start Date",
      sortable: true,
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    {
      field: "end_date",
      headerName: "End Date",
      sortable: true,
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    {
      field: "testimonial_link",
      headerName: "Testimonial",
      width: 130,
      renderCell: (params) => {
        const { testimonial_flag, testimonial } = params.row;
        const isAdminOrManager = login_user_role === "ADMIN" || login_user_role === "MANAGER";

        if (!isAdminOrManager) return null;

        if (testimonial_flag === "link") {
          return (
            <Tooltip title="Copy Testimonial Link">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopyTestimonialLink(params.row);
                }}
              >
                <ContentCopyIcon sx={{ fontSize: 20, color: "rgb(4,161,137)" }} />
              </IconButton>
            </Tooltip>
          );
        } else if (testimonial_flag === "download") {
          return (
            <Tooltip title="View Testimonial Video">
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenVideoModal(params.row);
                }}
              >
                <VisibilityIcon sx={{ fontSize: 20, color: "rgb(4,161,137)" }} />
              </IconButton>
            </Tooltip>
          );
        }
        return null;
      },
    },
    {
      field: "task_overview",
      headerName: "Task",
      width: 150,
      renderCell: (params) => (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
        // mt={3}
        >
          {renderOverviewCell(params, "task_overview")}
        </Box>
      ),
    },
    {
      field: "milestones_overview",
      headerName: "Milestone",
      width: 150,
      renderCell: (params) => (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
        >
          {renderOverviewCell(params, "milestones_overview")}
        </Box>
      ),
    },
    {
      field: "added_at",
      headerName: "Created Date",
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    {
      field: "updated_at",
      headerName: "Last Modified Date",
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("YYYY-MM-DD") : "N/A",
    },
    { field: "updated_name", headerName: "Last Modified By", width: 150 },

  ];
  const actionColumn = {
    field: "actions",
    headerName: "Action",
    width: 100,
    renderCell: (params) => (
      <Box display="flex" alignItems="center">
        <IconButton onClick={(event) => handleMenuOpen(event, params.row)}>
          <MoreVertIcon />
        </IconButton>
      </Box>
    ),
  };
  const projectColumns =
    login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [actionColumn, ...baseProjectColumns]
      : baseProjectColumns;
  // console.log("project_values :", selectedTask);
  // Update the columns dynamically based on the filter
  useEffect(() => {
    setColumns(projectColumns);
  }, [filter, login_user_role]);

  const transformResponse = (data) => {
    //console.log()("transformedData_in_projects tr+Daata ===", data);

    if (!Array.isArray(data)) {
      // console.error("Expected an array but got:", data);
      return [];
    }

    const rows = data.map((taskList) => ({
      id: `P-ID${taskList.owner_id}`, // Prefix for unique ID
      owner: taskList.owner_name,
      isTask: true,
      subtasks: Array.isArray(taskList.projects)
        ? taskList.projects.map((task) => {
          //console.log()("task_overview Data ===", task.milestones_overview);
          return {
            id: task.id,
            owner: "",
            project_Name: task.title,
            status: task.current_status_name || "N/A",
            budget_type: task.budget_type || task.budgetType || "-",
            completed: task.completed_percentage || "N/A",
            createdBy: task.added_by_name || "N/A",
            startDate: task.start_date
              ? new Date(task.start_date).toISOString().split("T")[0]
              : "N/A",
            endDate: task.end_date
              ? new Date(task.end_date).toISOString().split("T")[0]
              : "N/A",
            createdDate: task.added_at
              ? new Date(task.added_at).toISOString().split("T")[0]
              : "N/A",
            lastModifiedDate: task.updated_at
              ? new Date(task.updated_at).toISOString().split("T")[0]
              : "N/A",
            lastModifiedBy: task.updated_name || "N/A",
            issue_overview: task.issue_overview,
            milestones_overview: task.milestones_overview,
            task_overview: task.task_overview,
            isSubtask: true,
            parentId: `t${taskList.task_list_id}`,
          };
        })
        : [], // Return empty if `tasks` is undefined or not an array
    }));

    //console.log()("project_rows :", rows);
    return rows;
  };

  const getProjectStatusName = (project) => {
    if (typeof project.current_status_name === "string" && project.current_status_name.trim()) {
      return project.current_status_name.trim();
    }
    if (typeof project.status_name === "string" && project.status_name.trim()) {
      return project.status_name.trim();
    }
    if (typeof project.status === "string" && project.status.trim()) {
      return project.status.trim();
    }
    if (project.current_status_name?.status_name) {
      return project.current_status_name.status_name.trim();
    }
    if (project.status?.status_name) {
      return project.status.status_name.trim();
    }
    return "";
  };

  const fetchSearchedProjects = async (searchQuery) => {
    setLoading(true);
    try {
      const response = await filterEntities("/project/search", {
        search: searchQuery,
      });
      if (response.status) {
        let rawData = Array.isArray(response.data) ? response.data : [];
        if (
          filter !== "all_projects" &&
          filter !== "completed_projects" &&
          filter !== "view_by_owner"
        ) {
          rawData = rawData.filter((project) => {
            const projStatus = getProjectStatusName(project);
            if (!projStatus) return false;
            return projStatus.toLowerCase() === filter.trim().toLowerCase();
          });
        }
        const dataWithId = rawData.map((project) => ({
          ...project,
          id: project.project_id,
        }));
        setProjects(dataWithId);
      } else {
        setProjects([]);
      }
    } catch (error) {
      // console.error("Failed to fetch projects:", error);
      setProjects([]);
      // Handle the error appropriately in the caller
    } finally {
      setLoading(false);
    }
  };
  // Fetch projects using reusable service
  const fetchProjects = async () => {
    setLoading(true);

    try {
      if (
        filter === "all_projects" ||
        filter === "completed_projects" ||
        filter === "view_by_owner"
      ) {
        const response = await fetchEntityById("projects/show", filter);
        if (response && response.data) {
          const { data, total } = response.data;
          if (filter !== "view_by_owner") {
            const dataWithId = (
              Array.isArray(response.data) ? response.data : data || []
            ).map((project) => ({
              ...project,
              id: project.project_id,
            }));
        //console.log()("sope_filter_changed data with project  :", dataWithId);
            setProjects(dataWithId);
            setTotalRecords(total || dataWithId.length);
          } else {
            const transformedData = transformResponse(response?.data);
        //console.log()("transformedData_in_projects", transformedData);
            setProjects(transformedData);
          }
        } else {
          setProjects([]);
        }
      } else {
        // Filter is a status name (e.g., "Active", "Updates", "Completed", "Master of master", "New Status")
        let response;
        if (filter.toLowerCase() === "completed") {
          try {
            response = await fetchEntityById("projects/show", "completed_projects");
          } catch (e) {
            response = await fetchEntityById("projects/show", "all_projects");
          }
        } else {
          response = await fetchEntityById("projects/show", "all_projects");
        }

        if (response && response.data) {
          const allProjectsData = Array.isArray(response.data)
            ? response.data
            : response.data.data || [];

          const filteredProjects = allProjectsData.filter((project) => {
            const projStatus = getProjectStatusName(project);
            if (!projStatus) return false;
            return (
              projStatus.toLowerCase() === filter.trim().toLowerCase()
            );
          });

          const dataWithId = filteredProjects.map((project) => ({
            ...project,
            id: project.project_id,
          }));
          setProjects(dataWithId);
          setTotalRecords(dataWithId.length);
        } else {
          setProjects([]);
        }
      }
    } catch (error) {
      toast.error(error.message || "Failed to fetch projects");
    } finally {
      setLoading(false);
      setClearFilter(false);
    }
  };
  // useEffect(() => {
  //   fetchProjects();
  // }, [filter]);
  useEffect(() => {
    if (!isSearching) {
      fetchProjects();
    }
  }, [filter]);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) {
        fetchSearchedProjects(searchTerm.trim());
      } else {
        fetchProjects();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleFilterChange = (event) => {
    const value = event.target.value;
    //console.log()("sope_filter_changed ===", value);
    setFilter(value);
    setSearchTerm("")
    // setProjects(filteredProjects);
  };
  // Handle search input changes
  // const handleSearchChange = async (event) => {
  //   const value = event.target.value;
  //   setSearchTerm(value);
  //   if (value) {
  //     await fetchSearchedProjects(value);
  //   } else {
  //     await fetchProjects();
  //   }
  // };
  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
/*
    const trimmedValue = value.trim();
    setSearchTerm(trimmedValue);

   if (trimmedValue) {
     await fetchSearchedProjects(trimmedValue);
   } else {
     await fetchProjects();
   }
     
*/
  };

  const handleRowClick = (params) => {
    const { id, title } = params.row;
    const formattedId = id.toString().replace(/\s+/g, "-");
    login_user_role !== "CLIENT"
      ? navigate(`/projects/projectDetail/${formattedId}`, {
        state: { title },
      })
      : navigate(`/projects/projectDetail/${formattedId}/tasks`, {
        state: { title },
      });
  };

  const handleApplyFilter = (filteredData) => {
    setProjects(
      filteredData.map((project) => ({
        ...project,
        id: project.project_id, // Ensure DataGrid has a unique ID
      }))
    );
    setShowFilter(false); // Close filter sidebar
    setClearFilter(true);
  };

  const handleClearFilter = () => {
    fetchProjects();
    sessionStorage.removeItem("isFilterApplied");
    sessionStorage.removeItem("filtered_data");
  };

  const handleCloseFilter = () => setShowFilter(false); // Close filter
  const handleShowFilter = () => {
    setShowFilter(true); // Open filter
    sessionStorage.setItem("isFilterApplied", false);
  };
  const handleShowProject = () => setShowProject(true); // Open filter
  const handleCancel = () => setShowProject(false); // Open filter
  const handleAddProject = async (newProject) => {
    setProjects((prevProjects) => [...prevProjects, newProject]);
    await fetchProjects();
  };
  const handleUpdateProjectName = () => {
    setMenuAnchorEl(null); // Close the menu

    Swal.fire({
      title: "Update Project Name",
      input: "textarea",
      // inputLabel: "Project Name",
      inputValue: selectedTask.project_name,
      inputPlaceholder: "Enter new project name...",
      inputAttributes: {
        "aria-label": "Type your message here",
      },
      showCancelButton: true,
      confirmButtonText: "Yes, Update it!",
      showCloseButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
      showClass: {
        popup: "animate__animated animate__fadeInLeft",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },

      inputValidator: (value) => {
        if (!value.trim()) {
          return "Project name cannot be empty!";
        }
      },

      preConfirm: async (newTitle) => {
        try {
          const response = await editProjectDetails(
            "projects/update",
            selectedTask.project_id,
            {
              title: newTitle,
            }
          );
          fetchProjects();
          Swal.fire({
            title: "Updated!",
            text: "Project name updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              popup: "custom-swal-popup",
              confirmButton: "swal-confirm-btn",
              title: "custom-swal-title",
              text: "custom-swal-html",
              icon: "custom-swal-icon",
            },
          });
        } catch (error) {
          Swal.fire("Error", error.message || "Something went wrong", "error");
        }
      },
    });
  };

  const handleCopyTestimonialLink = async (row) => {
    // Dummy link for now as requested

    try {

      const res = await generateTestimonialLink({ url: `/testimonial/invite`, id: row.project_id });
      // console.log("res", res);
      navigator.clipboard.writeText(res?.data?.data?.link)
        .then(() => {
          toast.success("Testimonial link copied to clipboard!");
        })
        .catch((err) => {
          console.error("Failed to copy link: ", err);
          toast.error("Failed to copy link");
        });
    } catch (error) {
      console.error("Error fetching testimonial link: ", error);
      toast.error("Failed to fetch testimonial link");
    }
    finally {
      setMenuAnchorEl(null);
    }


  };
  const handleDeleteTestimonial = async () => {
    try {
      const res = await deleteTestimonial(selectedTask?.testimonial_id).unwrap();
      // console.log("response", res);

      if (res) {
        toast.success(res?.message);
        fetchProjects();
      }
    } catch (error) {
      console.error("Error deleting testimonial: ", error);
      toast.error(error?.message);
    } finally {
      setMenuAnchorEl(null);
      setDeleteModalOpen(false);
    }
  };

  const handleOpenVideoModal = (row) => {
    if (row.testimonial) {
      setSelectedVideoData({
        ...row.testimonial,
        project_title: row.title,
      });
      setVideoModalOpen(true);
    } else {
      toast.error("No testimonial video available.");
    }
  };

  const handleDownloadVideo = async (url, fileName) => {

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error("Network response was not ok");
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName || "testimonial_video.webm";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      toast.success("Download complete!");
    } catch (error) {
      console.error("Error downloading video:", error);
      toast.error("Failed to download video.");
    }
  };

  useEffect(() => {
    sessionStorage.setItem("isFilterApplied", false);
    sessionStorage.removeItem("filtered_data");
    sessionStorage.setItem("isIssueFilterApplied", false);
    sessionStorage.setItem("isTaskFilterApplied", false);
    sessionStorage.setItem("isMilestoneFilterApplied", false);
    sessionStorage.removeItem("issue_filter_data");
    sessionStorage.removeItem("task_filter_data");
    sessionStorage.removeItem("milestone_filter_data");
  }, []);
  // console.log("filtered_data_from state :", filterData);

  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        placement="end"
        className="custom-offcanvas"
        style={{ width: window.innerWidth <= 768 ? "90%" : "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <AddProjectComponent
            onClear={() => reset()}
            onCancel={handleCancel}
            onApply={handleAddProject}
            fetchProjects={fetchProjects}
          />
        </Offcanvas.Body>
      </Offcanvas>
      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        placement="end"
        style={{ width: window.innerWidth <= 768 ? "80%" : "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <FilterProjectComponent
            onApply={handleApplyFilter}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowFilter(false)}
          />
        </Offcanvas.Body>
      </Offcanvas>
      {/* Main section */}
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
      >
        <MenuItem onClick={handleUpdateProjectName}>
          <EditIcon sx={{ fontSize: 16, mr: 1, color: "rgb(4,161,137)" }} />
          Update Project Name
        </MenuItem>
        {selectedTask?.has_testimonials && (
          <MenuItem onClick={() => setDeleteModalOpen(true)}>
            <DeleteIcon sx={{ fontSize: 16, mr: 1, color: "red" }} />
            Delete Testimonial
          </MenuItem>
        )}
      </Menu>

      <div className="container-fluid bg-white p-3">
        {/* Top Section: Filter & Buttons */}
        {/* <div className="row align-items-center pb-2"> */}
        <Box
          className="row align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "10px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
            mx: 0,
          }}
        >
          {/* Filter Dropdown (Left side) */}
          <div className="col-12 col-lg-2 col-md-4" style={{ paddingLeft: 0 }}>
            <FormControl className="">
              <Select value={filter} onChange={handleFilterChange} size="small">
                {filterOptions.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Buttons & SearchBar (Right side) */}
          <div className="col-12 col-lg-10 col-md-8 d-flex flex-wrap justify-content-md-end gap-2 align-items-center" style={{ paddingRight: 0 }}>
            <SearchBar
              placeholder="Search Project"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />

            {clearFilter && (
              <button
                className="addmore_btn"
                disabled={loading}
                onClick={handleClearFilter}
              >
                Clear Filter
              </button>
            )}

            {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
              <Button
                className="rounded text-capitalize AddButton me-2 ms-2"
                onClick={handleShowProject}
              >
                Add New Projects
              </Button>
            )}

            {/* Filter Icon Button */}
            {/* <button
              className="border-0 p-2 rounded-circle text-decoration-none me-3 project-icon-bg" */}

            <Tooltip title="Filter">
              <IconButton
                onClick={handleShowFilter}
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  margin:"0 12px 0 10px",
                  width: "39px",
                  height: "39px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
              >
                
                <CiFilter className="text-rgbr-blue pro-icon-s" />
              </IconButton>
            </Tooltip>

            {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
              <CommonImportProject isProjectModule={true} haveText={false} />
            )}
          </div>
        {/* </div> */}
        </Box>

        {/* Table Section */}
        {loading ? (
          <Loader /> // Show loader while fetching data
        ) : (
          <div className="row ">
            <div className="col-12 ">
              <FilterSummaryBox
                onApply={handleApplyFilter}
                status_type={"PROJECT"}
                filter_path="/project/filter"
              />
            </div>
            <div className="col-12 mt-2">
              {filter !== "view_by_owner" ? (
                <Box
                  sx={{
                    width: "100%",
                  }}
                >
                  <DataGrid
                    rows={projects}
                    columns={columns}
                    onRowClick={handleRowClick}
                    loading={loading}
                    slots={{
                      noRowsOverlay: CustomNoRowsOverlay,
                    }}
                    getRowId={(row) => row.id}
                    pagination
                    disableColumnMenu
                    disableColumnSorting
                    disableColumnFilter
                    disableColumnSelector
                    pageSizeOptions={[10, 20, 30, 40]} // User can choose
                    paginationModel={paginationModel} // Controlled pagination
                    onPaginationModelChange={setPaginationModel} // Handle pagination
                    autoHeight
                  />
                </Box>
              ) : (
                <DataGrid
                  rows={getFlattenedRows()}
                  columns={columns}
                  getRowId={(row) => row.id}
                  pagination
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  disableSelectionOnClick
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  autoHeight
                />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Testimonial Video Modal */}
      <Dialog
        open={videoModalOpen}
        onClose={() => setVideoModalOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { minHeight: "520px" } }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Customer Testimonial Video</Typography>
            <IconButton size="small" onClick={() => setVideoModalOpen(false)}>
              ✕
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {selectedVideoData && (() => {
            const baseUrl = process.env.REACT_APP_API_BASE_URL
              ? process.env.REACT_APP_API_BASE_URL.replace(/\/api\/?$/, "")
              : "";
            const videoUrl = selectedVideoData.video_url?.startsWith("http")
              ? selectedVideoData.video_url
              : `${baseUrl}/storage/${selectedVideoData.video_url}`;
            return (
              <Box>
                <Box mb={2}>
                  <Box display="flex" mb={1}>
                    <Typography variant="subtitle2" sx={{ width: "120px", fontWeight: "bold" }}>Project Name</Typography>
                    <Typography variant="subtitle2" sx={{ mr: 1 }}>:</Typography>
                    <Typography variant="subtitle2">{selectedVideoData.project_title}</Typography>
                  </Box>
                  <Box display="flex" mb={1}>
                    <Typography variant="subtitle2" sx={{ width: "120px", fontWeight: "bold" }}>Name</Typography>
                    <Typography variant="subtitle2" sx={{ mr: 1 }}>:</Typography>
                    <Typography variant="subtitle2">{selectedVideoData.name}</Typography>
                  </Box>
                  <Box display="flex">
                    <Typography variant="subtitle2" sx={{ width: "120px", fontWeight: "bold" }}>Created At</Typography>
                    <Typography variant="subtitle2" sx={{ mr: 1 }}>:</Typography>
                    <Typography variant="subtitle2">{dayjs(selectedVideoData.added_at).format("DD-MM-YYYY")}</Typography>
                  </Box>
                </Box>

                <Box mt={2} mb={2} sx={{ width: "100%", textAlign: "center" }}>
                  <video
                    controls
                    controlsList="nodownload"
                    width="100%"
                    style={{ borderRadius: "8px", maxHeight: "320px" }}
                    src={videoUrl}
                  >
                    Your browser does not support the video tag.
                  </video>
                </Box>

                <Box mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={() =>
                      handleDownloadVideo(
                        videoUrl,
                        `${selectedVideoData.project_title}_testimonial.webm`
                      )
                    }
                    sx={{ backgroundColor: "rgb(4,161,137)", "&:hover": { backgroundColor: "rgb(3,130,110)" } }}
                  >
                    Download
                  </Button>
                </Box>
              </Box>
            );
          })()}
        </DialogContent>
      </Dialog>
      <Dialog open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the Testimonial for "
            <strong>{selectedTask?.project_name}</strong>"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={deleteLoading} onClick={() => setDeleteModalOpen(false)}>
            No
          </Button>
          <Button
            disabled={deleteLoading}
            onClick={handleDeleteTestimonial}
            color="error"
            variant="contained"
          >
            {deleteLoading ? <BtnLoader /> : "Yes"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Project;
